import { isDefined } from '@sama/js-core';
import {
  LineMaterial,
  LineMaterialParameters,
} from 'three/examples/jsm/lines/LineMaterial.js';
import { Point2D } from '../../../../team-apis/otterdam/answers/shape-typings';
import { H3Material } from '../../../materials/basic/h3-basic-material';
import { H3Defines } from '../../../materials/shared/definitions';

interface H3LineMaterialParameters
  extends Omit<LineMaterialParameters, 'color' | 'resolution'> {
  color?: string;
  resolution?: Point2D;
}

export class H3LineMaterial extends LineMaterial implements H3Material {
  override defines: H3Defines = {
    USE_LUT_PROJECTION: false,
    USE_CYLINDRICAL_PROJECTION: false,
    USE_DEFORMED_CYLINDRICAL_PROJECTION: false,
    USE_FISHEYE_PROJECTION: false,
    USE_MOTION_COMPENSATION: false,
    USE_BROWN_CONRADY_PROJECTION: false,
    IS_POINT: false,
    IS_CUBOID: false,
  };

  setUniform() {
    // noop
    // We don't want to use projection methods in this material
  }

  assignDefines() {
    // noop
    // We don't want to use projection methods in this material
  }

  override setValues(parameters: H3LineMaterialParameters = {}) {
    super.setValues(parameters);

    // setValues is called from the constructor via setValues when the uniform
    // is not yet defined
    if (isDefined(this.color) && parameters.color) {
      this.color.set(parameters.color);
    }

    if (isDefined(this.resolution) && parameters.resolution) {
      this.resolution.fromArray(parameters.resolution);
    }
  }
}
